import React from "react";
import Scroll from "../components/Scroll/Scroll";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

function App() {
  return (
    <div>
      <Scroll />
    </div>
  );
}

export default App;
